import BaseRestService from './baseRestService';

const _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.AppIntegrationRestService
 *
 * @description
 * This class contains methods used to retrieve/update information about app integrations
 * using http requests.
 */
export default class AppIntegrationRestService extends BaseRestService {

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    constructor($http, $q, Util) {

        super($http, $q, Util);

    }

    /**
     * @ngdoc function
     * @name rest.services.AppIntegrationRestService#getAllAsync
     * @methodOf rest.services.AppIntegrationRestService
     * @function
     *
     * @description
     * Retrieves app integrations.
     *
     * @returns {Promise} The promise of the call.
     */
    getAllAsync() {

        return super.getAllAsync(`app-integrations?filter[to]=dashboard&include=from&lang=${CWCONFIG.language}`);

    }

}

_serviceDependencies.push(AppIntegrationRestService);

angular.module('rest.services')
    .service('AppIntegrationRestService', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/restServices/appIntegrationRestService.js